import { AxiosInstance } from "axios"
import { DeviceDetails, DeviceDetailsDiagnostics } from "./deviceTypes"

// Device Details

export enum DeviceDetailsQuery {
    DETAILS = "device-details",
}

type DeviceDetailsParams = Readonly<{ deviceId: number }>

export type DeviceDetailsResponse = Readonly<{
    device: DeviceDetails
}>

export async function fetchDeviceDetails(
    { deviceId }: DeviceDetailsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DeviceDetailsResponse> {
    const { data } = await axios.get(`/devices/${deviceId}`, {
        signal,
    })
    return data
}

// Device Diagnostics
type DeviceDiagnosticsParams = Readonly<{ deviceId: number }>

export type DeviceDiagnosticsResponse = Readonly<DeviceDetailsDiagnostics>

export async function fetchDeviceDiagnostics(
    { deviceId }: DeviceDiagnosticsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DeviceDiagnosticsResponse> {
    const { data } = await axios.get(`/devices/${deviceId}/diagnostics`, {
        signal,
    })
    return data
}
